/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thermal_Shock_PlanningInputs */



/**
* | output |
* | --- |
* | "Thermal shock planning" |
*
* @param {Thermal_Shock_PlanningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const thermal_shock_planning = /** @type {((inputs?: Thermal_Shock_PlanningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thermal_Shock_PlanningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermal shock planning")
	return /** @type {LocalizedString} */ ("Planning de choc thermique")
});